import { Field, connect } from 'formik'

export const PlatformNewsletterCheckbox = connect(({ formik }) => {
  if (!formik.values._show_platform_subscription) return null

  // This will take the current ab test label text or fall back to the regular label if no AB test is given/active.
  //   Add labels at https://app.phrase.com/accounts/betterplace/search?query=donate.platform_newsletter_checkbox
  //   Eg 'donate.platform_newsletter_checkbox.ab_test_label_newsletter_subscription_1/alternative1'
  //   with Tag 'javascript'
  const label_ab_test_or_default = I18n.t(`donate.platform_newsletter_checkbox.ab_test_label_${formik.values._tracking_newsletter_ab}`,
    { defaultValue: I18n.t('donate.platform_newsletter_checkbox.label') }
  )

  return <Field name='newsletter'>
    {({field}) =>
      <div className='platform-donations-new-subscribe-to-platform-newsletter mb-3'>
        <label className='generic-custom-radio-field w-full mb-0' htmlFor='subscribeToPlatformNewsletter'>
          <input type='checkbox' {...field} id='subscribeToPlatformNewsletter' />
          <span className='generic-custom-radio' />
          <div data-info-ab-test={formik.values._tracking_newsletter_ab}>{label_ab_test_or_default}</div>
        </label>
      </div>
    }
  </Field>
})
